/* jshint esversion: 9 */
/**
 * Initialize Manage : 库存初始化管理
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}',
  items: [
    // 操作日志
    { key: 'getLogPage', url: '/operate-logs', method: 'GET' },
  ],
};
export default {
  ...generate(config),
};
